<template>
  <div class="block" v-if="!$utils.isCartOfflineShippable() && $utils.getShippingDetail().length > 0">
    <strong>วิธีการรับ{{ $config.PRODUCT_TYPE }}</strong>
    <ul>
      <li v-for="detail in $utils.getShippingDetail()">{{ detail }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'delivery-selector',
  methods: {
    setOfflineShipping (value) {
      this.$utils.setOfflineShipping(value)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DeliverySelector.vue?5f5d9afc